import React from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, css } from 'aphrodite/no-important';
import { CENTER, WHITE, MEDIA_QUERIES, BASE_SPACING } from '../styles';

const s = StyleSheet.create({
  root: {
    display: 'flex',
    appearance: 'none',
    borderWidth: 0,
    position: 'relative',
    alignItems: CENTER,
    width: '100%',
    padding: 10,
    backgroundColor: WHITE,
    marginBottom: 12,
    boxShadow: '9px 6px 9px 0px rgba(0,0,0,0.1)',
    outline: 0,
    [MEDIA_QUERIES.ON_DESKTOP]: {
      padding: BASE_SPACING,
    },
  },
});

const Panel = ({ __className, component, ...props }) =>
  React.createElement(component, {
    className: css(s.root, __className),
    ...props,
  });

Panel.propTypes = {
  component: PropTypes.any,
  __className: PropTypes.any,
};

Panel.defaultProps = {
  component: 'div',
};

export default Panel;
